import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-bold text-lg font-heading">汗汗漫画</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed">
              致力于提供最新最全的韩漫资源，全部支持免费在线观看，打造一个实时更新、覆盖无死角的韩漫大全内容库。
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              <a href="#quick-links" className="text-background-50 no-underline">快速链接</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { path: '/', label: '首页' },
                { path: '/category/all', label: '全部分类' },
                { path: '/category/romance', label: '恋爱漫画' },
                { path: '/category/fantasy', label: '奇幻漫画' },
                { path: '/about', label: '关于我们' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              <a href="#hot-categories" className="text-background-50 no-underline">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { path: '/category/bl', label: '耽美漫画' },
                { path: '/category/thriller', label: '悬疑漫画' },
                { path: '/category/action', label: '动作漫画' },
                { path: '/category/comedy', label: '搞笑漫画' },
                { path: '/category/drama', label: '剧情漫画' },
              ].map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-background-50">
              <a href="#contact" className="text-background-50 no-underline">联系我们</a>
            </h4>
            <ul className="space-y-2.5 text-foreground-400 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5"></i>
                <span>contact@hanhancomic.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5"></i>
                <span>本站所有资源均来自互联网，仅供学习交流使用</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 汗汗漫画 - 最新最全韩漫免费在线观看平台。本站内容仅供学习交流，请于下载后24小时内删除。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors whitespace-nowrap">使用条款</a>
            <a href="#" className="text-foreground-500 hover:text-background-50 text-xs transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}